import Vue from 'vue';
import Component from 'vue-class-component';

@Component
/**
 * Mixin for direct meeting links
 */
export default class DirectLinkMixin extends Vue {
  /**
   * Returns an Guest Direct Link string
   * @param {any} webrtcAlias - The rooms alias
   * @return {string} - The meeting url
   */
  __MIXINwebrtcAliasDirectLink(webrtcAlias: any): string {
    const a = document.createElement('a');
    a.href = this.$router.resolve({
      name: 'welcome-guest',
      params: {
        webrtcAlias: webrtcAlias,
      },
    }).href;
    return a.href;
  }
  /**
   * Returns an Host Direct Link string
   * @param {any} webrtcAlias - The rooms alias
   * @return {string} - The meeting url
   */
  __MIXINmeetingRoomDirectLink(webrtcAlias: any): string {
    // return this.webrtcAliasDirectLink(meetingRoom.webrtc.alias);
    const a = document.createElement('a');
    a.href = this.$router.resolve({
      name: 'host',
      params: {
        webrtcAlias: webrtcAlias,
      },
    }).href;
    return a.href;
  }
  /**
   * Returns an Host Direct Link string from a webrtc alias
   * @param {any} meeting - The meeting object
   * @return {string} - The meeting url
   */
  __MIXINmeetingDirectLink(meeting: any): string {
    return this.__MIXINwebrtcAliasDirectLink(meeting.meeting_room.webrtc.alias);
  }
}
